(function () {
    "use strict";

    var controllerId = "TopNavController";

    angular
        .module("app.shell")
        .directive("headerScroll", ["$window", headerScroll])

        .controller(controllerId, [
            "$scope",
            "$rootScope",
            "userSvc",
            "$state",
            "guardSvc",
            "$timeout",
            TopNavController,
        ]);

    function TopNavController(
        $scope,
        $rootScope,
        userSvc,
        $state,
        guardSvc,
        $timeout
    ) {
        $scope.lang = $rootScope.lang;
        // $scope.version = $window.appVersion;
        if ($state.current.name.indexOf("property") === -1) $scope.showModalMobile = true;

        // Listen for property cleanup to ensure navigation state is reset
        $scope.$on('property:cleanup', function () {
            $timeout(function () {
                delete $rootScope.hideTopNavOnScroll;
                $scope.$digest();
            }, 0);
        });


        $scope.guardSvc = guardSvc;
        $scope.scrollTop = function () {
            if ($state.current.name.indexOf("default") > -1) window.scrollTo(0, 0);
        };

        $scope.activeMobileCurrency = false;
        $scope.mobileCurrency = function () {
            $scope.activeMobileCurrency = !$scope.activeMobileCurrency;
        };
        $scope.$on("documentClicked", function (event, element) {
            if ($scope.activeMobileCurrency && !element.hasClass('ei-language')) {
                $scope.activeMobileCurrency = false;
                $scope.$apply();
            }
        });

        $scope.handleAppBtn = function (platform = null) {
            window.dataLayer.push({
                event: "mobile_modal",
                action: platform === 'apple' ? 'App Store redirection' :
                    (platform === 'android' ? 'Google Play redirection' : 'Stay on the web'),
                platform: platform,
                language: window.lang.split('-')[0]
            });

            if (!platform) return;

            /* window.location.href = platform === 'apple' ?
            'https://apps.apple.com/us/app/endeksa-value-sell-property/id1272606231' :
            'https://play.google.com/store/apps/details?id=com.endeksa.app' */

            window.location.href = 'https://lsgt.adj.st?adj_t=1fhc5z7j&adj_deeplink_js=1&adj_fallback=https%3A%2F%2Fwww.endeksa.com%2F&adj_redirect_macos=https%3A%2F%2Fwww.endeksa.com%2F';


        };

        $scope.modalMobileShow = $rootScope.isMobileOrTablet() && !$rootScope.refMobile && !window.isHeadless() && window.location.href.indexOf('/atlas') === -1;

        $scope.initModalMobile = function () {
            $scope.platform = /iPad|iPhone|iPod/.test(navigator.userAgent) ? 'apple' : 'android';

        };

        // $scope.links = navigationSvc.getLinks();

        $rootScope.signOut = function () {
            userSvc.signOut().then(
                function () {
                    // $window.location = $state.href("default", {
                    //     langcode: $rootScope.lang,
                    // });
                    $state.go("default", {
                        langcode: $rootScope.lang,
                    });
                },
                function (rej) {
                    console.log(rej);
                }
            );
        };


        guardSvc.hasPackage([
            "eco-package",
            'seller-lead-package',
            "premium-package",
            "premiumplus-package",
            "pro-ee-package",
            "flex-package",
            "gold-package",
            "terminal-flex-package",
            "terminal-pro-package",
            "platinum-package",
            "premium-ee-package",
            "terminal-premium-package",
            "terminal-package",
            "real-estate-package",
            "location-package"]).then(function (result) {
                $rootScope.isPro = result;
            });

        guardSvc.hasPackage([
            "eco-package",
            "premium-package",
            "premiumplus-package",
            "pro-ee-package",
            "flex-package",
            "gold-package",
            "terminal-flex-package",
            "terminal-pro-package",
            "platinum-package",
            "premium-ee-package",
            "terminal-premium-package",
            "terminal-package",
            "real-estate-package",
            "location-package"]).then(function (result) {
                $rootScope.isProWithoutSellerLead = result;
            });

        guardSvc.hasPackage([
            "eco-package",
            'seller-lead-package',
            "premium-package",
            "premiumplus-package",
            "pro-ee-package",
            "flex-package",
            "gold-package",
            "terminal-flex-package",
            "terminal-pro-package",
            "platinum-package",
            "premium-ee-package",
            "terminal-premium-package",
            "terminal-package",
            "real-estate-package"]).then(function (result) {
                $rootScope.isAgent = result;
            });

        $scope.$on("userSvc:signedInChanged", function () {
            $rootScope.SignedIn = userSvc.info.SignedIn;
            $rootScope.user = userSvc.info;
            guardSvc.hasPackage([
                "eco-package",
                'seller-lead-package',
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "real-estate-package",
                "location-package"]).then(function (result) {
                    $rootScope.isPro = result;
                });

            guardSvc.hasPackage([
                "eco-package",
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "terminal-package",
                "real-estate-package",
                "location-package"]).then(function (result) {
                    $rootScope.isProWithoutSellerLead = result;
                });

            guardSvc.hasPackage([
                "eco-package",
                'seller-lead-package',
                "premium-package",
                "premiumplus-package",
                "pro-ee-package",
                "flex-package",
                "gold-package",
                "terminal-flex-package",
                "terminal-pro-package",
                "platinum-package",
                "premium-ee-package",
                "terminal-premium-package",
                "terminal-package",
                "real-estate-package"]).then(function (result) {
                    $rootScope.isAgent = result;
                });

        });
        $rootScope.user = userSvc.info;
        $rootScope.isMobile = function () { return window.isMobile(); };

        $scope.menuVisible = false;
        $scope.openMenu = function () {
            $("#mobile-menu").show();
            $scope.menuVisible = true;
            $timeout(function () {
                window.Beamer.init();
            });
        };

        $scope.closeMenu = function () {
            $("#mobile-menu").hide();
            $scope.menuVisible = false;
        };

    }

    function headerScroll($window) {
        var directive = {
            scope: {
                offset: "@",
            },
            link: function (scope, element) {
                var scheduledAnimationFrame = false;
                var lastScrollY = 0;
                var isActive = true;

                function readAndUpdatePage() {
                    if (!isActive) {
                        scheduledAnimationFrame = false;
                        return;
                    }

                    if (lastScrollY > 25) {
                        if (!element.hasClass("nav-scroll-target")) {
                            element.addClass("nav-scroll-target");
                        }
                    } else {
                        // Always remove nav-scroll-target when scrolled to top, unless on Renta
                        if (!$window.isRenta && element.hasClass("nav-scroll-target")) {
                            element.removeClass("nav-scroll-target");
                        }
                    }
                    scheduledAnimationFrame = false;
                }

                function onScroll() {
                    lastScrollY = window.scrollY || 0;

                    if (scheduledAnimationFrame) {
                        return;
                    }

                    scheduledAnimationFrame = true;
                    requestAnimationFrame(readAndUpdatePage);
                }

                // Bind scroll handler
                angular.element($window).bind("scroll", onScroll);

                // Listen for property cleanup event to reset state
                var propertyCleanupListener = scope.$root.$on('property:cleanup', function () {
                    // Force reset nav state
                    lastScrollY = 0;
                    element.removeClass("nav-scroll-target");
                    element.removeClass("hide-on-property-scroll");

                    // Re-trigger scroll check
                    setTimeout(function () {
                        onScroll();
                    }, 150);
                });

                // Clean up on destroy
                scope.$on('$destroy', function () {
                    isActive = false;
                    angular.element($window).unbind("scroll", onScroll);
                    if (propertyCleanupListener) {
                        propertyCleanupListener();
                    }
                });

                // Initial check
                setTimeout(function () {
                    onScroll();
                }, 100);
            },
        };
        return directive;
    }
})();
